// @ts-nocheck

import { userActionCreators } from '../../actions';
import { CommonActionTypes } from '../../types/actions/common';
import { common as CommonUtils } from '../../utils';
import fetch from '../../utils/fetch';
import { type HandlerProps } from '../synchronousMiddleware';
const { setDisconnected } = userActionCreators;

export const handledActionTypes = [CommonActionTypes.API_CALL];

const apiMiddlewareHandler = ({ store, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === CommonActionTypes.API_CALL) {
      const { options, hooks } = action?.payload ?? {};
      const { before, received, success, failure } = hooks || {};
      const { url, method, forwardWamUserIp, ...rest } = options;

      if (typeof before === 'function') {
        before();
      }

      (async function () {
        let ip = null;
        if (forwardWamUserIp) {
          try {
            const response = await fetch('https://wapi-ipv6.winamax.fr/core/tools/http-helper/ip');
            const json = await response.json();
            ip = json.data.ip;
          } catch (err) {
            // ignore
          }
          if (ip) {
            rest.headers = {
              ...rest.headers,
              'x-wam-user-ip': ip,
            };
          }
        }

        const errorInfo = {
          request: { url, body: options.body },
          response: null,
        };

        let response = null;
        try {
          response = await fetch(url, { ...rest, method });
        } catch (error) {
          if (typeof failure === 'function') {
            failure(error, errorInfo);
          }
        }

        if (!response) {
          return;
        }

        let json = null;
        try {
          json = await response.clone().json();
        } catch (error) {
          if (typeof failure === 'function') {
            try {
              errorInfo.response = await response.text();
            } catch (error) {
              failure(error, errorInfo);
            }
            failure(error, errorInfo);
          }
        }

        if (!json) {
          return;
        }

        if (typeof received === 'function') {
          const jsonCamelCased = CommonUtils.convertToCamelCase(json);
          if (jsonCamelCased.ecode === 1) {
            store.dispatch(setDisconnected());
          }
          received(response, jsonCamelCased);
        }

        if (typeof success === 'function') {
          const jsonCamelCased = CommonUtils.convertToCamelCase(json);
          if (jsonCamelCased.ecode === 1) {
            store.dispatch(setDisconnected());
          }
          success(jsonCamelCased);
        }
      })();
    }
  }
};

export default apiMiddlewareHandler;
